/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupscolumnflags2Inputs */

const en_signupscolumnflags2 = /** @type {(inputs: Signupscolumnflags2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signals`)
};

const de_signupscolumnflags2 = /** @type {(inputs: Signupscolumnflags2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signale`)
};

/**
* | output |
* | --- |
* | "Signals" |
*
* @param {Signupscolumnflags2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupscolumnflags2 = /** @type {((inputs?: Signupscolumnflags2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupscolumnflags2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupscolumnflags2(inputs)
	return de_signupscolumnflags2(inputs)
});
export { signupscolumnflags2 as "signupsColumnFlags" }